import { ColumnCsvParser } from 'AppConfig/TableConfig/ColumnCsvParser';

// "Render.ResultsProcessStatementTable.EvalYear"
const parseExpression = (input) => {
  const PREFIX = 'Parser.';

  if (!input.startsWith(PREFIX)) {
    return undefined;
  }

  const path = input.slice(PREFIX.length).split('.');
  if(!(path || []).length) {
    return undefined;
  }

  return path.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : null, ColumnCsvParser);
}

export const getCustomColumnCsvParser = (key) => {
  try {
    const parserFunction = parseExpression(key);
    if(!parserFunction) {
      return undefined;
    }

    return parserFunction;
  }
  catch (error) {
    console.error(error);
    return `ParserError:${key}`;
  }
}
